import { useUserProfile } from '@/services/user/hooks';
import { useDevOverride } from '@/stores/devOverridesStore';
import { NON_OVERRIDABLE_ACTIONS, can, type Action } from './capabilities';

// false means policy denied. Inside <ProtectedRoute> the profile is always
// resolved, so this never returns "false because still loading".
export function useCan(action: Action): boolean {
  const profile = useUserProfile();
  const override = useDevOverride(action);
  // Dev-panel capability overrides are honoured only for users who really hold
  // admin.dev-panel (backend enforces real roles regardless), and never for the
  // NON_OVERRIDABLE_ACTIONS that would let an admin lock themselves out.
  if (override !== undefined && !NON_OVERRIDABLE_ACTIONS.includes(action) && can('admin.dev-panel', profile)) {
    return override;
  }
  return can(action, profile);
}
